import type { Country } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useCountries } from "./useCountries"

const defaultCountries: Country[] = []

/*
 * return the country corresponding with the countryCode
 */
export function useCountry(countryCode: string): Country | undefined {
  const countries = useCountries().data ?? defaultCountries

  return useMemo(
    () => countries.find((country) => country.country_code === countryCode),
    [
      countries,
      countryCode,
    ],
  )
}
